
<template>
  <div>
    <div class="bill-item-row">
      <div
        v-for="(header, headerIndex) in headers"
        :key="'header-items-'+headerIndex"
        class="bill-item pa-2"
      >
        <div class="bill-item-title">
          {{ header.text }}
        </div>
      </div>
    </div>

    <div
      v-for="(item, itemIndex) in itemDetails"
      :key="'item-Index-'+itemIndex"
      class="bill-item-row"
    >
      <div
        v-for="(header,index) in headers"
        :key="header.value+'-'+index"
        class="bill-item pa-2"
      >
        <div class="bill-item-value">
          {{ header.formatter?header.formatter(item[header.value]):item[header.value] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { providers as providerEnum } from '@/modules/judicialFees/helpers/enum';

export default {
  name: 'BillItemDetails',
  components: {},
  props: {
    itemDetails: {
      type: Array,
      required: true,
    },
    provider: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        {
          value: 'productName',
          text: this.local.judicialFees.billDetailsHeader[this.providerProductName()],
        },
        {
          value: 'providerItemCode',
          text: this.local.judicialFees.billDetailsHeader.providerItemCode,
        },
        {
          value: 'totalPrice',
          text: this.local.judicialFees.billDetailsHeader.amountInSAR,
          formatter: (val) => { return `${val} ${this.local.judicialFees.sar}`; },
        },
      ],
    };
  },
  computed: {},
  watch: {},
  mounted() { },
  methods: {
    providerProductName() {
      let key = 'Product';
      if (providerEnum.icms == this.provider) {
        key = 'icms' + key;
      } else if (providerEnum.exec == this.provider) {
        key = 'exec' + key;
      }
      return key;
    },
  },

};
</script>

<style lang="scss" scoped>
.bill-item-row {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
}

.bill-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  padding: 0 10px 0 10px;
}

    .bill-item-title {
        font-size: 14px;
        font-weight: bold;
        color: var(--app-primary-color);
    }

.bill-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: var(--app-dark-primary-color);
}
</style>
